import React, { useContext, useEffect, useState } from 'react'
import SEOTAG from '../../../utils/CommonFunctionality/SEO/AllpagesSEO'
import ProductContainer from './ProductContainer'
import './Auctiontracker.css'
import Layout from '../Layout'
import ListCard from './ListCard'
import LiveAuctionTrackerCard from './LiveAuctionTrackerCard'
import PriceTracker from './PriceTracker'
import { useParams } from 'react-router-dom'
import BuyerContext from '../../../Product/context/buyer/buyerContext'

const AuctionTracker = (props) => {
    const [value, setValue] = React.useState(0)
    const [selectedProduct, setSelectedProduct] = React.useState({})
    const [toggleLiveAuction, setToggleLiveAuction] = React.useState(true)
    const [toggleDetailsAuction, setToggleDetailsAuction] = React.useState(true)
    const [pid] = useState(new URLSearchParams(window.location.search.substring(1)).get('pid'))
    const buyerContext = useContext(BuyerContext)
    const { product_view, getViewProduct } = buyerContext

    const handleChange = (event, newValue) => {
        setValue(newValue)
    }

    useEffect(() => {
        if (product_view.results?.id && product_view.results?.id == pid) {
            setSelectedProduct({
                ...product_view.biddetails,
                ...product_view.results,
                incrementamt: product_view.incrementamt,
            })
        }
    }, [product_view.results?.id])

    useEffect(() => {
        getViewProduct({
            product_id: pid,
            bundle_info: global?.storeConfigration?.pallet_auction?.value == 1 ? 1 : undefined,
        })
    }, [pid])

    const handleToggleLiveAuction = () => {
        setToggleLiveAuction(!toggleLiveAuction)
    }

    const handleToggleDetailsAuction = () => {
        setToggleDetailsAuction(!toggleDetailsAuction)
    }

    return (
        <>
            <SEOTAG page="Auction Tracker" />
            <Layout props={props}>
                <div className="customContainer mx-auto px-4 mt-4">
                    <ProductContainer pid={pid} data={selectedProduct} />
                    <div className="listFlexContainer">
                        <ListCard data={selectedProduct} />
                    </div>
                    <div className="LiveAccordionTracker">
                        <div
                            className="LiveAccordionTrackerHeader"
                            onClick={() => handleToggleLiveAuction()}
                        >
                            <h3 className="h3">Live Auctions</h3>
                            <span className="material-icons-outlined">
                                {toggleLiveAuction ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
                            </span>
                        </div>
                        {toggleLiveAuction && (
                            <div className="LiveAccordionTrackerBody">
                                <LiveAuctionTrackerCard data={selectedProduct} />
                            </div>
                        )}
                    </div>
                    <div className="pricingOuterContainer">
                        <PriceTracker />
                    </div>
                    <div className="proDescInnerBox">
                        <div className="proDesccontainer">
                            <div
                                className="DetailsAccordionTrackerHeader"
                                onClick={() => handleToggleDetailsAuction()}
                            >
                                <h3 className="h3">Product Description & Details</h3>
                                <span className="material-icons-outlined">
                                    {toggleDetailsAuction
                                        ? 'keyboard_arrow_up'
                                        : 'keyboard_arrow_down'}
                                </span>
                            </div>
                            {toggleDetailsAuction && (
                                <div className="proAccordionTrackerBody">
                                    <p>
                                        Looking for the best price on Sony WH-1000XM5 Wireless Noise
                                        Cancelling Headphones? Retail Rush tracks live liquidation
                                        auction prices for this product (ASIN: B08N5WRWNW, UPC:
                                        027242920811), helping you save an average of $85.00 (21%
                                        off the $399.99 retail price). With 1247 units sold and 8
                                        active auctions, now is the perfect time to find incredible
                                        deals on this popular headphones product.
                                    </p>
                                    <p>
                                        Looking for the best price on Sony WH-1000XM5 Wireless Noise
                                        Cancelling Headphones? Retail Rush tracks live liquidation
                                        auction prices for this product (ASIN: B08N5WRWNW, UPC:
                                        027242920811), helping you save an average of $85.00 (21%
                                        off the $399.99 retail price). With 1247 units sold and 8
                                        active auctions, now is the perfect time to find incredible
                                        deals on this popular headphones product.
                                    </p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Layout>
        </>
    )
}

export default AuctionTracker
